import {REQUEST_PAYMENT_TYPES, REQUEST_PAYMENT_TYPES_FAILURE, REQUEST_PAYMENT_TYPES_SUCCESS} from "../../../constant/master/TransPaymentTypeConstant";

const initialState = {
    payment_types: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const paymentTypesReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_PAYMENT_TYPES:
            return {
                ...state,
                payment_types: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_PAYMENT_TYPES_SUCCESS:
            return {
                ...state,
                payment_types: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_PAYMENT_TYPES_FAILURE:
            return {
                ...state,
                payment_types: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
